import { render } from "./sPRTResult.vue?vue&type=template&id=6b496544&scoped=true"
import script from "./sPRTResult.vue?vue&type=script&lang=js"
export * from "./sPRTResult.vue?vue&type=script&lang=js"

import "./sPRTResult.vue?vue&type=style&index=0&id=6b496544&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b496544"]])

export default __exports__